import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TombOfAkhenatenGameConfig} from "../TombOfAkhenatenGameConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {TOAGameEvent} from "../events/TOAGameEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Elastic, TimelineLite, TweenLite} from "gsap";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {TombOfAkhenatenParsedGameData} from "../server/data/TombOfAkhenatenParsedGameData";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {TombOfAkhenatenGameMode} from "../gameMode/TombOfAkhenatenGameMode";
import {IBetWayWinData, IBetWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {TombOfAkhenatenGameModuleConfig} from "../TombOfAkhenatenGameModuleConfig";
import {WildPart} from "../enums/WildPart";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TOAWildSymbol} from "./TOAWildSymbol";
import {TombOfAkhenatenReelController} from "../reel/TombOfAkhenatenReelController";
import {TombOfAkhenatenTextStyles} from "../config/TombOfAkhenatenTextStyles";
import {SoundManager} from "../sound/SoundManager";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";

export class TOAScatterOverlayView extends BaseView {
    private _layer: ScalableLayer;
    private _bonusContainer: PIXI.Container;
    private _wildLandContainer: PIXI.Container;
    private _bonusSpinesCreatedFor: number[] = [];
    private _gameData: TombOfAkhenatenParsedGameData | null;
    private _nearWinPositions: boolean[] = [];
    private _reelWinPositions: boolean[] = [];
    private _scatterPositions: number[] = [];
    private _frameFireContainer: PIXI.Container;
    private _bonusIdleAnimContainer: PIXI.Container;
    private _isAborted: boolean = false;
    private _isRestore: boolean = false;
    private _isAnticipationStarted: boolean = true;
    private _akhenatenSpinTl: TimelineLite;
    private _extraWildTl: TimelineLite;
    private _awardedSpinTlArr: TimelineLite[] = [];

    private static getSpineMaskPosition(rowCount: number): number {
        let maskPosY: number = 0;
        if (rowCount === 4) {
            maskPosY = -130;
        } else if (rowCount === 5) {
            maskPosY = -160;
        }
        return maskPosY;
    }

    protected initAnimations() {
        super.initAnimations && super.initAnimations();
        this.createLayerMask();
        //this.playWildLandingAnim(17, 0); //only for test
        //this.playBonusIdleAnimation(13); only for test
        //TweenLite.delayedCall(5,()=> this.showAwardedSpins("+1", 2));
    }

    private createLayerMask(): void {
        const gameConfig: TombOfAkhenatenGameConfig = TombOfAkhenatenGameConfig.instance;

        this._layer = StageManager.getLayer(gameConfig.LAYERS.OVERLAY_SPINES.name);

        const layerMask: PIXI.Graphics = new PIXI.Graphics();
        layerMask.beginFill(0xFFFF0B, 0.5);
        layerMask.drawRect(gameConfig.REEL_AREA_POS_X, gameConfig.REEL_AREA_POS_Y, gameConfig.REEL_AREA_WIDTH, gameConfig.REEL_AREA_HEIGHT);
        layerMask.endFill();
        this._layer.mask = layerMask;

        this._bonusContainer = new PIXI.Container();
        this._wildLandContainer = new PIXI.Container();
        this._bonusIdleAnimContainer = new PIXI.Container();
        this._bonusContainer.name = "bonusSpinesContainer";
        this._wildLandContainer.name = "wildLandSpinesContainer";
        this._bonusIdleAnimContainer.name = "bonusIdleAnimContainer";

        this._frameFireContainer = this.createFireContainer();
        this._frameFireContainer.name = "anticipationFire";
        this._frameFireContainer.position.set(gameConfig.REEL_AREA_WIDTH * 0.5, gameConfig.REEL_AREA_POS_Y);

        this._layer.addChild(layerMask, this._wildLandContainer, this._bonusContainer, this._bonusIdleAnimContainer, this._frameFireContainer);

        this.stopFrameAnticipation();
    }

    private createFireContainer(): PIXI.Container {
        const spineTextures: PIXI.spine.core.SkeletonData = GameResources.getSpineAsset("frameAnticipationSpine");

        let fireContainer: PIXI.Container = new PIXI.Container,
            topFire: PIXI.spine.Spine = new PIXI.spine.Spine(spineTextures),
            rightFire: PIXI.spine.Spine = new PIXI.spine.Spine(spineTextures),
            bottomFire: PIXI.spine.Spine = new PIXI.spine.Spine(spineTextures),
            leftFire: PIXI.spine.Spine = new PIXI.spine.Spine(spineTextures);

        topFire.scale.set(1, -1);
        topFire.position.set(0, 27);

        rightFire.scale.set(1, -1);
        rightFire.rotation = (6.28 / 4);
        rightFire.position.set(332, 360);

        bottomFire.scale.set(1, 1);
        bottomFire.position.set(0, 566);

        leftFire.scale.set(1, 1);
        leftFire.rotation = (6.28 / 4);
        leftFire.position.set(-333, 360);

        fireContainer.addChild(topFire, rightFire, bottomFire, leftFire);

        return fireContainer;
    }

    private playFrameAnticipation(): void {
        //Logger.logDev("FrameAnticipation playFrameAnticipation isAnticipationStarted : " + this._isAnticipationStarted);
        if (!this._isAnticipationStarted) {
            //Logger.logDev("FrameAnticipation playFrameAnticipation success");
            this._isAnticipationStarted = true;
            SoundManager.playScatterAnticipationSound();
            for (let i: number = 0; i < this._frameFireContainer.children.length; i++) {
                let spine: PIXI.spine.Spine = this._frameFireContainer.children[i] as PIXI.spine.Spine;
                spine.updateTransform();
                spine.visible = true;
                spine.state.setAnimation(0, "purple", true);
            }
        }
        EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.START_SHAKE, true));
    }

    private stopFrameAnticipation(): void {
        const gameConfig: TombOfAkhenatenGameConfig = TombOfAkhenatenGameConfig.instance;

        //Logger.logDev("FrameAnticipation stopFrameAnticipation isAnticipationStarted : " + this._isAnticipationStarted);
        if (this._isAnticipationStarted) {
            this._isAnticipationStarted = false;
            SoundManager.stopScatterAnticipationSound();
            //Logger.logDev("FrameAnticipation stopFrameAnticipation success");
            for (let i: number = 0; i < this._frameFireContainer.children.length; i++) {
                let spine: PIXI.spine.Spine = this._frameFireContainer.children[i] as PIXI.spine.Spine;
                spine.state.clearTracks();
                spine.visible = false;
            }
        }

        if (this._gameData?.singleWin === 0) {
            for (let i: number = 0; i < gameConfig.REELS_NUM; i++) {
                TombOfAkhenatenGameModuleConfig.symbolStateHandler.changeStateOfSymbols(i, 0, gameConfig.SYMBOL_STATES.normal!);
            }
        }
        EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.STOP_SHAKE));
    }

    private initDataParsed(data: TombOfAkhenatenParsedGameData) {
        //#347
        this._gameData = data;
        this._nearWinPositions = data.nearWinPositions?.reduce((acc, currEl) => acc.concat(<any>currEl), []);
        this._scatterPositions = [];
        data.reels.forEach((symaArr, reelID) => {
            if (symaArr[0] === "S") {
                this._scatterPositions.push(reelID);
            }
        })
    }

    private onServerDataParsed(data: TombOfAkhenatenParsedGameData): void {
        this._isRestore = false;
        this._gameData = data;
        const currentBetWinData: IBetWinData[] = this._gameData.betWins;
        this._nearWinPositions = this._gameData.nearWinPositions.reduce((acc, currEl) => acc.concat(<any>currEl), []);

        let scatterArray = this._gameData.scatterPositions!.reduce((acc, currEl) => acc.concat(<any>currEl), []);
        this._scatterPositions = scatterArray.reduce(function (a: number[], e, i) {
            if (e) {
                a.push(i);
            }
            return a;
        }, []);

        for (let i: number = 0; i < currentBetWinData.length; i++) {
            const reelWinPos = (currentBetWinData[i] as IBetWayWinData).reelWinPositions;
            reelWinPos.forEach((arr, col) => {
                arr.forEach((value, row) => {
                    const index = col * 5 + row;
                    this._reelWinPositions[index] = this._reelWinPositions[index] ? this._reelWinPositions[index] || value : value;
                })
            });
        }

        // this._extraWildPosition = data.extraWildPosition;
    }

    private static getSymbolPosition(reelId: number): number[] {
        return Helper.getSymbolPositions(reelId, 0);
    }

    private static symTextScaling(rowCount: number): number {
        let textScale: number = 1;

        switch (rowCount) {
            case 4:
                textScale = 0.9;
                break;

            case 5:
                textScale = 0.8;
                break;
        }

        return textScale;
    }

    private static getBonusPartsPositions(spineName: string, numOfRows: number): number[] {
        let partPosition: number[],
            rowCount = numOfRows;

        if (rowCount === 3) {
            partPosition = [0, 85];
            switch (spineName) {
                case "bonusFrameBottomSpine":
                    partPosition = [0, 85];
                    break;

                case "bonusHandSpine":
                    partPosition = [0, 96];
                    break;

                case "bonusTextSpine":
                    partPosition = [0, 91];
                    break;

                case "bonusCloudBottomSpine":
                    partPosition = [0, -96];
                    break;
            }
        } else if (rowCount === 4) {
            partPosition = [0, 85];
            switch (spineName) {
                case "bonusFrameBottomSpine":
                    partPosition = [0, 34];
                    break;

                case "bonusTextSpine":
                    partPosition = [0, 47];
                    break;

                case "bonusCloudBottomSpine":
                    partPosition = [0, -140];
                    break;

                case "bonusAnticipationSpine":
                    partPosition = [0, 75];
                    break;
            }
        } else {
            partPosition = [0, 85];
            switch (spineName) {
                case "bonusFrameBottomSpine":
                    partPosition = [0, 4];
                    break;

                case "bonusHandSpine":
                    partPosition = [0, 75];
                    break;

                case "bonusTextSpine":
                    partPosition = [0, 40];
                    break;

                case "bonusCloudBottomSpine":
                    partPosition = [0, -170];
                    break;

                case "bonusAnticipationSpine":
                    partPosition = [0, 60];
                    break;
            }
        }

        return partPosition;
    }

    private static getAnimationProperties(animType: string): any {
        let animName: any[] = [];

        switch (animType) {
            case "bonusLanding":
                animName = ["bonusLandingAnimation", 0, 0, 0.833];
                break;

            case "bonusLandingLoop":
                animName = ["bonusLandingloopAnimation", -1, 0, 0.533];
                break;

            case "bonusNearWin":
                animName = ["bonusLoopAnimation", -1, 0.467, 0.533];
                break;

            case "bonusNoWin":
                animName = ["bonusLoopNoWinAnimation", 0, 0.533, 0.533];
                break;

            case "bonusWin":
                animName = ["bonusLoopWinAnimation", 0, 0.533, 0.9];
                break;
        }

        //return name, loopCount, initTime, duration
        return animName;
    }

    protected addEventListeners(): void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this.initDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => this.onServerDataParsed(event.params[0]));
        EventHandler.addEventListener(this, TOAGameEvent.PLAY_BONUS_SPINE, (event: GameEvent) => this.initBonusSpineAnimation(event.params[0], event.params[1]));
        EventHandler.addEventListener(this, TOAGameEvent.PLAY_WILD_LANDING, (event: GameEvent) => this.playWildAnim(event.params[0], event.params[1]));
        EventHandler.addEventListener(this, TOAGameEvent.ON_NEW_GAME_ROUND, () => this.onNewGameRound());
        EventHandler.addEventListener(this, TOAGameEvent.ON_STONE_PRESS, (event: GameEvent) => this.onStonePress(event.params[0]));
        EventHandler.addEventListener(this, TOAGameEvent.ON_SPIN_ABORT, (event: GameEvent) => this.onAbort(event.params[0]));
        EventHandler.addEventListener(this, TOAGameEvent.ON_STONE_PRESS_ABORT, () => this.onStoneAbort());
        EventHandler.addEventListener(this, TOAGameEvent.ON_RESTORE, (event: GameEvent) => this.onRestore(event.params[0]));
        EventHandler.addEventListener(this, TOAGameEvent.PLAY_SCATTER_END_ANIM, () => this.onSpinStopped());
        EventHandler.addEventListener(this, SpinEvent.FINISH, () => this.removeAllAnimations());
        EventHandler.addEventListener(this, TOAGameEvent.REMOVE_WILD_LANDING_ANIMS, () => this.removeWildLandingAnims());
        EventHandler.addEventListener(this, TOAGameEvent.REMOVE_SCATTER_ANIMS, () => this.removeScatterAnimations());
        EventHandler.addEventListener(this, TOAGameEvent.BONUS_WIN_NOWIN, (event: GameEvent) => this.handleSymStates(event.params[0]));
        EventHandler.addEventListener(this, TOAGameEvent.PLAY_BONUS_IDLE, (event: GameEvent) => this.playBonusIdleAnimation(event.params[0]));
        EventHandler.addEventListener(this, TOAGameEvent.PLAY_WILD_TRANSFORM, (event: GameEvent) => this.playWildTransformation(event.params[0], event.params[1]));
        EventHandler.addEventListener(this, TOAGameEvent.SHOW_AWARDED_AKHENATEN_SPINS, (event: GameEvent) => this.showAkhenatenSpins(event.params[0]));
        EventHandler.addEventListener(this, TOAGameEvent.SHOW_AWARDED_SPINS, (event: GameEvent) => this.showAwardedSpins(event.params[0], event.params[1]));
    }

    private onStoneAbort() {
        if (this._extraWildTl?.isActive()) {
            this._extraWildTl.progress(1);
        }
        if (this._awardedSpinTlArr.length) {
            this._awardedSpinTlArr.forEach((awardedTl) => {
                if (awardedTl?.isActive()) {
                    awardedTl.progress(1);
                }
            });
        }
    }

    private onRestore(rowCount: number) {
        this._isRestore = true;
        //413
        let scattersToAvoid: number[] = rowCount <= 4 ? [0, 1, 5, 6, 10, 11, 15, 16, 20, 21] : [0, 5, 10, 15, 20],
            scattersToCheck: number[] = this._scatterPositions.filter(e => !scattersToAvoid.includes(e));

        for (let i: number = 0; i < scattersToCheck.length; i++) {
            EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.PLAY_BONUS_SPINE, scattersToCheck[i], "bonusLanding"));
        }
        this.onStonePress(rowCount);
    }

    private isNormalOrFreespin(): boolean {
        let nextMode: string | undefined = this._gameData?.nextMode,
            flag: boolean = false;

        if (nextMode && (nextMode === TombOfAkhenatenGameMode.NORMAL || nextMode === TombOfAkhenatenGameMode.FREESPIN)) {
            flag = true;
        }
        return flag;
    }

    private isBonusGame(): boolean {
        let flag: boolean = false,
            mode: string | undefined = this._gameData?.mode;

        if (mode && TombOfAkhenatenGameConfig.instance.BONUS_GAME_MODES.indexOf(mode) > -1) {
            flag = true;
        }

        return flag;
    }

    private getSpineContainer(reelId: number): PIXI.Container {
        let symSpineContainer: PIXI.Container = new PIXI.Container();

        if (this._bonusSpinesCreatedFor.indexOf(reelId) === -1) {
            symSpineContainer = this.createSpineContainer(reelId);
        } else {
            this._bonusContainer.children.forEach(function (symAnimsContainer) {
                if ((symAnimsContainer as PIXI.Container).name === "symSpineContainer_" + reelId) {
                    symSpineContainer = (symAnimsContainer as PIXI.Container);
                }
            });
        }

        return symSpineContainer;
    }

    private onSpinStopped(): void {
        if (this.isBonusGame()) {
            return;
        }

        let _this = this,
            bonusCount = _this._bonusSpinesCreatedFor.length;

        const tl: TimelineLite = new TimelineLite();

        if (bonusCount > 1 && _this.isNormalOrFreespin()) {
            for (let i = 0; i < _this._scatterPositions.length; i++) {
                tl.add(() => {
                    //fix for #202 commented below coz reelid 0 was treated as false
                    if (_this._scatterPositions.length) {
                        _this.playBonusEndingAnimation(_this._scatterPositions[i]);
                    }
                }, 1);
            }
        }
        // if(this._extraWildPosition.length && this._extraWildPosition[0] > 0){
        //     //this.playWildTransformation(this._extraWildPosition);
        // }
    }

    private initBonusSpineAnimation(reelId: number, animType: any): void {
        let _this = this,
            spineContainer = _this.getSpineContainer(reelId),
            landingAnimation = TOAScatterOverlayView.getAnimationProperties("bonusLanding"),
            landingLoopAnimation = TOAScatterOverlayView.getAnimationProperties("bonusLandingLoop"),
            winAnimation = TOAScatterOverlayView.getAnimationProperties("bonusWin"),
            anticipationAnimation = TOAScatterOverlayView.getAnimationProperties("bonusNearWin"),
            bonusCount = TombOfAkhenatenReelController.SCATTER_COUNT;

        const tl: TimelineLite = new TimelineLite();

        (<PIXI.spine.Spine[]>(spineContainer as PIXI.Container).children).forEach(function (spinePart: PIXI.spine.Spine) {
            if (spinePart.name.indexOf("symSpineMask_") === -1) {
                spinePart.updateTransform();
                spinePart.visible = true;
                tl.add(() => {
                    TweenLite.fromTo(spineContainer, 0.1, {alpha: 0}, {alpha: 1});
                }, 0);
                if (_this.isBonusGame() || _this._gameData?.wasFeatureBuy) {
                    tl.add(() => {
                        //#369
                        /*if(spinePart.name === "bonusCombinedSpine"){
                            SoundManager.playScatterHighlightSound();
                        }*/
                        new SpineTween((spinePart as PIXI.spine.Spine), 0, winAnimation[0], winAnimation[1]);
                    }, 0.05);
                } else {
                    if (_this._isRestore && bonusCount >= 2) {
                        tl.add(() => {
                            new SpineTween((spinePart as PIXI.spine.Spine), 0, anticipationAnimation[0], anticipationAnimation[1]);
                        }, 0);
                    } else if (bonusCount < 2) {
                        tl.add(() => {
                            new SpineTween((spinePart as PIXI.spine.Spine), 0, landingAnimation[0], landingAnimation[1]);
                        }, landingAnimation[2]);
                    } else {
                        tl.add(() => {
                            new SpineTween((spinePart as PIXI.spine.Spine), 0, anticipationAnimation[0], anticipationAnimation[1]);
                        }, landingLoopAnimation[2]);
                    }
                }
            }
        });

        if (!(this.isBonusGame()) && this._nearWinPositions.indexOf(true) > -1) {
            if (bonusCount === 2) {
                for (let i: number = 0; i < bonusCount; i++) {
                    if (this._bonusSpinesCreatedFor[i]) {
                        this.playBonusAnticipation(this._bonusSpinesCreatedFor[i]);
                        //#321
                        // if(this._bonusSpinesCreatedFor.length === 2 && i === 1){
                        //     //SoundManager.playScatterAnticipationSound();
                        //     let isNextSpinANewRound: boolean | null = (this._gameData && (this._gameData.nextMode === TombOfAkhenatenGameMode.NORMAL || this._gameData.nextMode === TombOfAkhenatenGameMode.FREESPIN));
                        //     if(this._isAborted && isNextSpinANewRound){
                        //         //SoundManager.stopScatterAnticipationSound();
                        //     }
                        // }
                    }
                }
            } else {
                if (bonusCount > 2) {
                    this.playBonusAnticipation(reelId);
                }
            }
        }
    }

    private playBonusEndingAnimation(reelId: number): void {
        let _this = this,
            bonusCount = _this._bonusSpinesCreatedFor.length,
            spineContainer = _this.getSpineContainer(reelId),
            noWinAnimation = TOAScatterOverlayView.getAnimationProperties("bonusNoWin"),
            winAnimation = TOAScatterOverlayView.getAnimationProperties("bonusWin"),
            animToPlay = (bonusCount > 2) ? winAnimation : noWinAnimation;

        (<PIXI.spine.Spine[]>(spineContainer as PIXI.Container).children).forEach(function (spinePart: PIXI.spine.Spine) {
            if (spinePart.name.indexOf("symSpineMask_") === -1) {
                spinePart.state.clearTrack(0);
                spinePart.skeleton.setToSetupPose();
                spinePart.updateTransform();
                spinePart.visible = true;
                spinePart.state.setAnimation(0, animToPlay[0], animToPlay[1]);
            }
        });
        //#369
        if (animToPlay[0] === "bonusLoopWinAnimation" && (reelId === this._scatterPositions[this._scatterPositions.length - 1])) {
            SoundManager.playScatterHighlightSound();
        }
        this.stopFrameAnticipation();
    }

    private onNewGameRound(): void {
        this._isAborted = false;
        this.removeAllAnimations();
        this._bonusSpinesCreatedFor = [];
        this._nearWinPositions = [];
        this._reelWinPositions = [];
        this._scatterPositions = [];
        this._gameData = null;
        this._awardedSpinTlArr.length = 0;
    }

    private removeAllAnimations(): void {
        this.stopFrameAnticipation();
        this.removeAnims(this._bonusContainer);
        //this.removeAnims(this._wildContainer);
        this.removeWildLandingAnims();
        this.removeBonusIdleAnims();
    }

    private removeScatterAnimations(): void {
        this.removeAnims(this._bonusContainer);
        this.removeBonusIdleAnims();
        for (let i: number = 0; i < this._frameFireContainer.children.length; i++) {
            (this._frameFireContainer.children[i]).visible = false;
        }
    }

    private removeWildLandingAnims(): void {
        this.removeAnims(this._wildLandContainer);
    }

    private removeAnims(container: PIXI.Container): void {
        container.children.forEach(function (child) {
            //413
            TweenLite.to(child, 0.05, {
                alpha: 0,
                onComplete: () => {
                    child?.parent?.removeChild(child);
                }
            });
        });
    }

    private removeBonusIdleAnims(): void {
        this.removeAnims(this._bonusIdleAnimContainer);
    }

    private createSpineContainer(reelId: number): PIXI.Container {
        const gameConfig: TombOfAkhenatenGameConfig = TombOfAkhenatenGameConfig.instance;

        let symSpineContainer: PIXI.Container = new PIXI.Container(),
            symSpineMask: PIXI.Graphics = new PIXI.Graphics(),
            rowCount: number = gameConfig.ACTIVE_ROWS_NEXT_SPIN,
            symPos: number[] = reelId != undefined && TOAScatterOverlayView.getSymbolPosition(reelId) || [0, 0],
            maskX: number = (0 - (gameConfig.SYMBOL_WIDTH / 2) - 50),
            maskY: number = (0 - (gameConfig.SYMBOL_HEIGHT_FOR_OVERLAPPING_SYMBOLS / 2) - 50),
            maskW: number = (gameConfig.SYMBOL_WIDTH + 100),
            maskH: number = (gameConfig.SYMBOL_HEIGHT_FOR_OVERLAPPING_SYMBOLS + 100);

        symSpineMask.beginFill(0xFFFF0B, 0.5);
        symSpineMask.drawRect(maskX, maskY, maskW, maskH);
        symSpineMask.endFill();
        symSpineMask.name = "symSpineMask_" + reelId;
        symSpineMask.position.set(0, TOAScatterOverlayView.getSpineMaskPosition(rowCount));

        symSpineContainer.name = "symSpineContainer_" + reelId;
        symSpineContainer.position.set(symPos[0], symPos[1]);

        const spinesArray: string[] = [
            "bonusCombinedSpine", "bonusFrameShineSpine", "bonusCloudTopSpine",
            "bonusHeadSpine", "bonusFrameBottomSpine", "bonusWinBackgroundSpine", "bonusCloudBottomSpine",
            "bonusHandSpine", "bonusTextSpine", "bonusAnticipationSpine"
        ];
        for (let i: number = 0; i < spinesArray.length; i++) {
            let currentSpine = spinesArray[i],
                currentSpinePos: number[] = TOAScatterOverlayView.getBonusPartsPositions(currentSpine, gameConfig.ACTIVE_ROWS_NEXT_SPIN),
                spinePart: PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset(currentSpine));

            spinePart.name = currentSpine;
            spinePart.position.set(currentSpinePos[0], currentSpinePos[1] - 3); //#232
            spinePart.visible = false;

            if (currentSpine.indexOf("CloudBottom") > -1) {
                spinePart.scale.set(-1);
            }

            if (currentSpine.indexOf("TextSpine") > -1) {
                spinePart.scale.set(TOAScatterOverlayView.symTextScaling(rowCount));
            }

            if (currentSpine.indexOf("bonusCombinedSpine") > -1) {
                spinePart.mask = symSpineMask;
            }

            symSpineContainer.addChild(spinePart);
        }
        symSpineContainer.addChild(symSpineMask);

        this._bonusContainer.addChild(symSpineContainer);
        this._bonusSpinesCreatedFor.push(reelId);

        symSpineContainer.pivot.y = -3; //To fix #107
        return symSpineContainer;
    }

    private onAbort(rowCount: number): void {
        this._isAborted = true;
    }

    private onStonePress(rowCount: number): void {
        this.removeWildLandingAnims();
        let _this = this;
        const tl: TimelineLite = new TimelineLite(),
            gameConfig: TombOfAkhenatenGameConfig = TombOfAkhenatenGameConfig.instance;

        tl.add(() => {
            for (let i: number = 0; i < _this._bonusSpinesCreatedFor.length; i++) {
                let reelId = _this._bonusSpinesCreatedFor[i],
                    symNewPosY: number = 0,
                    actualSymPosY: number = TOAScatterOverlayView.getSymbolPosition(reelId)[1],
                    symSpineContainer = _this.getSpineContainer(reelId),
                    isFinalSpin = this._gameData?.nextMode === TombOfAkhenatenGameMode.RESPIN_FINAL || this._gameData?.nextMode === TombOfAkhenatenGameMode.FS_RESPIN_FINAL;

                if (rowCount === 4) {
                    symNewPosY = 49.5 * (gameConfig.MAX_ROWS - (reelId % gameConfig.MAX_ROWS));
                } else if (rowCount === 5) {
                    symNewPosY = (29 * (gameConfig.MAX_ROWS - (reelId % gameConfig.MAX_ROWS))) + 1.75;
                }

                if (this._isRestore) {
                    const sym = Reels.getSymbol(reelId, 0);
                    const symY = sym ? (sym.parent.y + sym.y) : 0;
                    symSpineContainer.position.y = gameConfig.REEL_AREA_POS_Y + symY;
                } else {
                    TweenLite.fromTo(symSpineContainer.position, gameConfig.STONE_PRESS_DURATION, {
                        y: actualSymPosY
                    }, {
                        delay: gameConfig.STONE_PRESS_START_DELAY,
                        y: isFinalSpin ? actualSymPosY : actualSymPosY + symNewPosY,
                        ease: Elastic.easeOut.config(1, 0.5)
                    });
                }

                (<PIXI.spine.Spine[]>(symSpineContainer as PIXI.Container).children).forEach(function (spinePart: PIXI.spine.Spine) {
                    TweenLite.fromTo(spinePart.position, gameConfig.STONE_PRESS_DURATION, {
                        y: spinePart.y
                    }, {
                        delay: gameConfig.STONE_PRESS_START_DELAY,
                        y: (spinePart.name.indexOf("symSpineMask_") === -1) ? TOAScatterOverlayView.getBonusPartsPositions(spinePart.name, rowCount)[1] : TOAScatterOverlayView.getSpineMaskPosition(rowCount),
                        ease: Elastic.easeOut.config(1, 0.5)
                    });

                    if (spinePart.name.indexOf("TextSpine") > -1) {
                        TweenLite.to(spinePart.scale, gameConfig.STONE_PRESS_DURATION, {
                            x: TOAScatterOverlayView.symTextScaling(rowCount),
                            y: TOAScatterOverlayView.symTextScaling(rowCount)
                        });
                    }
                });
            }
        });
    }

    private playBonusAnticipation(reelId: number): void {
        if (!reelId) {
            return;
        }
        let spineContainer = this.getSpineContainer(reelId),
            anticipationAnimation = TOAScatterOverlayView.getAnimationProperties("bonusNearWin");

        this.playFrameAnticipation();

        (<PIXI.spine.Spine[]>(spineContainer as PIXI.Container).children).forEach(function (spinePart: PIXI.spine.Spine) {
            if (spinePart.name.indexOf("symSpineMask_") === -1) {
                spinePart.state.clearTrack(0);
                spinePart.skeleton.setToSetupPose();
                spinePart.updateTransform();
                spinePart.visible = true;
                spinePart.state.setAnimation(0, anticipationAnimation[0], anticipationAnimation[1]);
            }
        });

        for (let i: number = 0; i < TombOfAkhenatenGameConfig.instance.REELS_NUM; i++) {
            this.setWinNoWinSymState(i);
        }
        //to handle wildLandOverlay for semi dimmed or no win state.#135
        if (this._wildLandContainer.children.length) {
            (<PIXI.Container[]>this._wildLandContainer.children).forEach(this.applyTintOnWildLanding, reelId);
        }
    }

    private setWinNoWinSymState(reelId: number): void {
        if (this._gameData?.wasFeatureBuy) {
            return;
        }
        const gameConfig: TombOfAkhenatenGameConfig = TombOfAkhenatenGameConfig.instance;
        if (this._reelWinPositions[reelId]) {
            TombOfAkhenatenGameModuleConfig.symbolStateHandler.changeStateOfSymbols(reelId, 0, gameConfig.SYMBOL_STATES.semiDimmed!);
        } else {
            TombOfAkhenatenGameModuleConfig.symbolStateHandler.changeStateOfSymbols(reelId, 0, gameConfig.SYMBOL_STATES.noWin!);
        }
    }

    private handleSymStates(reelId: number): void {
        let bonusCount: number = this._bonusSpinesCreatedFor.length,
            prevReelsForWinNoWin: number[] = [];

        if (reelId < this._nearWinPositions.indexOf(true)) {
            prevReelsForWinNoWin.push(reelId);
        }

        if (bonusCount > 1) {
            let len = prevReelsForWinNoWin.length;
            for (let i: number = 0; i < len; i++) {
                this.setWinNoWinSymState(prevReelsForWinNoWin[i]);
            }
            this.setWinNoWinSymState(reelId);
        }
    }

    private createWildMask(reelId: number): PIXI.Graphics {
        const symSpineMask: PIXI.Graphics = new PIXI.Graphics(),
            gameConfig: TombOfAkhenatenGameConfig = TombOfAkhenatenGameConfig.instance,
            maskX: number = (0 - (gameConfig.SYMBOL_WIDTH / 2) - 50),
            maskY: number = (0 - (gameConfig.SYMBOL_HEIGHT_FOR_OVERLAPPING_SYMBOLS / 2) - 50),
            maskW: number = (gameConfig.SYMBOL_WIDTH + 100),
            maskH: number = (gameConfig.SYMBOL_HEIGHT_FOR_OVERLAPPING_SYMBOLS + 100);

        symSpineMask.beginFill(0xFFFF0B, 0.5);
        symSpineMask.drawRect(maskX, maskY, maskW, maskH);
        symSpineMask.endFill();
        symSpineMask.name = "symSpineMask_" + reelId;
        return symSpineMask;
    }

    private playBonusIdleAnimation(reelId: number) {
        this.removeBonusIdleAnims();
        const symPos: number[] = TOAScatterOverlayView.getSymbolPosition(reelId);
        const timeline = new TimelineLite();
        const spine: PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("bonusIdle"));
        spine.name = "bonusIdle";
        this._bonusIdleAnimContainer.addChild(spine);
        spine.position.set(symPos[0], symPos[1] - 4); //#232
        spine.pivot.y = -88;
        timeline.add(new SpineTween(spine, 0, "bonusIdle", 0), 0);
        timeline.add(TweenLite.to(spine, 0.001, {alpha: 1}), 0);
        timeline.play();
        return;
    }

    private playWildAnim(reelId: number, isParticipatingOnWin: boolean) {
        const rowCount: number = TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN;
        let bottomFramePosition: number = -70,
            bottomPartSpinPos: number = 8,
            textPositioning: number = -22,
            textScaling: number = 0.8,
            symMaskHeight: number = 168;
        const symPos: number[] = TOAScatterOverlayView.getSymbolPosition(reelId);
        const wildAnimContainer: PIXI.Container = new PIXI.Container();

        if (rowCount === 4) {
            bottomFramePosition = -41;
            textScaling = 0.9;
            symMaskHeight = 176;
        }

        this._wildLandContainer.addChild(wildAnimContainer);
        const timeline: TimelineLite = new TimelineLite();

        const bottomCutPartSpine: PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset(WildPart.BOTTOM_CUT));
        const mask: PIXI.Graphics = this.createWildMask(reelId);
        const bottom_partSpine: PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset(WildPart.BOTTOM));
        const wild_top_partSpine: PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset(WildPart.TOP));
        const wild_text: PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset(WildPart.TEXT));

        bottomCutPartSpine.name = WildPart.BOTTOM_CUT;
        bottom_partSpine.name = WildPart.BOTTOM;
        wild_top_partSpine.name = WildPart.TOP;
        wild_text.name = WildPart.TEXT;
        wildAnimContainer.addChild(mask, bottom_partSpine, wild_top_partSpine, bottomCutPartSpine, wild_text);
        this._wildLandContainer.addChild(wildAnimContainer);
        wildAnimContainer.pivot.x = 1;
        wildAnimContainer.pivot.y = 5;
        wildAnimContainer.position.set(symPos[0], symPos[1]);
        bottom_partSpine.mask = mask;
        wild_top_partSpine.mask = mask;
        wild_text.y = rowCount === 3 ? 15.5 : 13;
        wild_top_partSpine.y = 8;
        bottom_partSpine.y = rowCount === 3 ? 9 : 8;
        bottomCutPartSpine.y = rowCount === 3 ? 8 : 7;

        //to handle wildLandOverlay for semi dimmed or no win state.#135
        TombOfAkhenatenReelController.SCATTER_COUNT > 1 && this.applyTintOnWildLanding(wildAnimContainer, reelId);

        wildAnimContainer.children.forEach((child: any) => {
            if (rowCount !== 3) {
                if (child.name == WildPart.BOTTOM_CUT) {
                    child.y = bottomFramePosition;
                } else if (child.name == WildPart.BOTTOM || child.name == WildPart.TOP) {
                    child.y = bottomPartSpinPos;
                } else if (child.name == WildPart.TEXT) {
                    child.position.set(0, textPositioning);
                    child.scale.set(textScaling);
                } else if (child.name.indexOf("symSpineMask_") != -1) {
                    child.height = symMaskHeight;
                    child.y = bottomFramePosition;
                }
            }
            if (child instanceof PIXI.spine.Spine) {
                !isParticipatingOnWin && (child.tint = 0x555555);
                timeline.add(new SpineTween((child as any), 0, "landing_animation", 0), 0);
                timeline.add(TweenLite.to(child, 0.001, {alpha: 1}), 0);
            }
        });

        timeline.play();
    }

    private applyTintOnWildLanding(wildAnimContainer: PIXI.Container, reelId: number) {
        wildAnimContainer.children.forEach((child: any) => {
            //fix for #222
            if (this._reelWinPositions[reelId]) {
                child.tint = 0xadadad;
            } else {
                child.tint = 0x555555;
            }
        });
    }

    private playWildTransformation(wildPos: number[], isAbort: boolean = false) {
        if (this._extraWildTl?.isActive()) {
            this._extraWildTl.progress(1).kill();
        }
        this._extraWildTl = new TimelineLite();
        const reelId: number = wildPos[0] * 5 + wildPos[1];
        const symbol = Reels.getSymbol(reelId, 0);
        if (symbol && symbol.symName === "W") {
            return;
        }
        const symPos: number[] = TOAScatterOverlayView.getSymbolPosition(reelId);
        const wildBlastSprite: TimelineSprite = new TimelineSprite(GameResources.getTextures("wildBlast"));
        wildBlastSprite.blendMode = PIXI.BLEND_MODES.ADD;
        this._layer.addChild(wildBlastSprite);
        wildBlastSprite.anchor.set(0.5);
        wildBlastSprite.position.set(symPos[0], symPos[1]);

        if (!isAbort) {
            SoundManager.playExtraWildLandingSound();
        }

        this._extraWildTl.add(wildBlastSprite.getAnimationAutoShowHide(true, true));
        this._extraWildTl.add(() => {
            !isAbort && TombOfAkhenatenReelController.SCATTER_COUNT < 2 && EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.START_SHAKE));
        }, 0.2);
        this._extraWildTl.add(() => {
            TOAScatterOverlayView.replaceWildSym(reelId)
            //EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.REPLACE_WILD_SYM, reelId));
        }, 0.5);

        isAbort && this._extraWildTl.progress(1);
    }

    private static replaceWildSym(reelId: number) {
        let reelController = Reels.getReel(reelId);
        if (reelController) {
            const wildSym = new TOAWildSymbol("W", reelId, TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.normal);
            const reelSym = reelController.allSymbols.pop();
            if (reelSym) {
                wildSym.position.set(reelSym.position.x, reelSym.position.y);
                reelSym.parent?.addChild(wildSym);
                reelSym.visible = false;
                //reelSym.onRemove();
                //reelSym.parent?.removeChild(reelSym);
                reelController.removedChildOnView(reelSym)
                reelController.allSymbols.push(wildSym);
            }
            (reelController as TombOfAkhenatenReelController).reOrderSymbols();
        }
    }

    private showAwardedSpins(awardedSpins: string, reelId: number) {
        const reelSym = Reels.getSymbol(reelId, 0);
        if (reelSym) {
            const spins: PIXI.Text = new PIXI.Text(awardedSpins, TombOfAkhenatenTextStyles.AWARDED_SPIN_SMALL);
            const tl: TimelineLite = new TimelineLite();
            const spinsShadow: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("spinsShadow")[0]);
            spins.anchor.set(0.5, 0);
            spins.alpha = 0;
            spinsShadow.anchor.set(0.5, 0);
            spinsShadow.scale.set(0.5, 1);
            spinsShadow.alpha = 0;
            spinsShadow.blendMode = PIXI.BLEND_MODES.ADD;

            this._layer.addChild(spinsShadow, spins);
            const animYPosDisplacement: number = 100;
            const x = reelSym.position.x + reelSym.parent.position.x;
            const y = reelSym.position.y + reelSym.parent.position.y + animYPosDisplacement - 80;
            spins.position.set(x, y);
            spinsShadow.position.set(x, y);
            tl.add([
                TweenLite.to(spins, 0.2, {alpha: 1}),
                TweenLite.to(spinsShadow, 0.2, {alpha: 1}),
            ], 0.2);
            tl.add([
                TweenLite.to(spins, 0.8, {y: spins.y - animYPosDisplacement}),
                TweenLite.to(spinsShadow, 0.8, {y: spins.y - animYPosDisplacement}),
            ], 0.3);
            tl.add([
                TweenLite.to(spins, 0.4, {alpha: 0}),
                TweenLite.to(spinsShadow, 0.4, {alpha: 0}),
            ], 1);
            tl.add(() => {
                this._layer.removeChild(spinsShadow);
                this._layer.removeChild(spins);
            }, 1.5);
            this._awardedSpinTlArr.push(tl);
        }
    }

    private showAkhenatenSpins(awardedSpins: string) {
        //spinText
        const spins: PIXI.Text = new PIXI.Text(awardedSpins, TombOfAkhenatenTextStyles.AWARDED_SPIN),
            gameConfig: TombOfAkhenatenGameConfig = TombOfAkhenatenGameConfig.instance;
        if (this._akhenatenSpinTl?.isActive()) {
            this._akhenatenSpinTl.progress(1).kill();
        }
        this._akhenatenSpinTl = new TimelineLite();
        const spriteTl: TimelineSprite = new TimelineSprite(GameResources.getTextures("akhenatenSpins"));
        this._layer.addChild(spriteTl, spins);
        spins.anchor.set(0.5);
        spins.alpha = 0;
        spriteTl.anchor.set(0.5);
        spriteTl.position.set(gameConfig.REEL_AREA_POS_X + gameConfig.REEL_AREA_WIDTH * 0.5,
            gameConfig.REEL_AREA_POS_Y + gameConfig.REEL_AREA_HEIGHT * 0.5);
        spins.position.set(gameConfig.REEL_AREA_POS_X + gameConfig.REEL_AREA_WIDTH * 0.5,
            gameConfig.REEL_AREA_POS_Y + gameConfig.REEL_AREA_HEIGHT * 0.5 - spins.height * 0.5);
        this._akhenatenSpinTl.add(spriteTl.getAnimationAutoShowHide(true, false));
        this._akhenatenSpinTl.add(TweenLite.to(spins, 0.5, {alpha: 1}), 0.4);
        this._akhenatenSpinTl.add(TweenLite.to(spins, 0.5, {alpha: 0}), 1.28);

        this._akhenatenSpinTl.add(() => {
            this._layer.removeChild(spriteTl);
            this._layer.removeChild(spins);
        }, 1.7);
        if (GameSetting.isFastSpin) {
            this._akhenatenSpinTl.timeScale(1.5);
        }
        if (this._isAborted) {
            this._akhenatenSpinTl.timeScale(2);
        }
    }
}